module.exports = __webpack_public_path__ + "media/images/font/Gustavo-LightItalic-2bd310dffed267c6e13fb014bf218ea1.woff2";